import React from "react"
import ReactDOM from "react-dom"

/** Useful for things like tooltips and modals, when having issues with overlap/z-index */
export default class EndOfBodyPortal extends React.PureComponent {
  constructor(props) {
    super(props)
    this.container = document.getElementById("end-of-body")
    this.el = document.createElement("div")
  }

  componentDidMount() {
    if (this.container) {
      this.container.appendChild(this.el)
    }
  }

  componentWillUnmount() {
    if (this.container) {
      this.container.removeChild(this.el)
    }
  }

  render() {
    if (!this.container) {
      return null
    }
    return ReactDOM.createPortal(this.props.children, this.el)
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/EndOfBodyPortal.jsx